import MainAddress from "../";
import { GetSerialProgram } from "../../util/sessionManager";
import { GetWithExpiry } from "../../util/sessionManager";
import axios from 'axios';

export async function ReadReport(data){
    try{
        const response = await axios.post(
            MainAddress+"SalesAnalysis/read_report.php",
            {
                ...data,
                serial_program:GetSerialProgram(),
            }
          )
          console.log(response)
        if(response.data[0].success){
            return {
                success:true,
                response:response.data
            }
        }else{
            return {
                success:false,
                message:response
            };
        }
    }catch(error){
        return {
            success:false,
            message:error
        };
    }

}